module.exports = __webpack_public_path__ + "e1ca6e007c91d4ef9ee063940b504870.png";


//////////////////
// WEBPACK FOOTER
// ./webserver/document_root/s/js/plugins/contentBox/img/buttons-slice.png
// module id = 952
// module chunks = 176 193 194